/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuMultiSelectList_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterMatchingSets_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuFilterMatchingSets_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuMultiSelectList_searchBrowse$ref,
  +$refType: SbSharedRefineMenuFilterMatchingSets_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterMatchingSets_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectList_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '93c195620df5d12da9deb9cb4f6d32d2';
module.exports = node;
